import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import type { StoreGroup } from "../../Objects/StoreGroups/StoreGroup"
import type { StoreGroupInvite } from "../../Objects/StoreGroups/StoreGroupInvite"
import { GetRequest } from "../../services/ApiClientService"

export const useGetStoreGroups = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleError = (error: unknown) => {
    const message = error instanceof Error ? error.message : t("label_unknown_error_description")

    setError(t("label_title_erro"), message)
  }

  const handleGetStoreGroups = async (): Promise<StoreGroup[]> => {
    try {
      enableLoad()

      const response = await GetRequest<StoreGroup[]>(API_ROUTES.STORE_GROUPS.GET_ALL)

      if (response.success) {
        return response.data ?? []
      }

      throw new Error(response.message)
    } catch (error) {
      handleError(error)
      return []
    } finally {
      disableLoad()
    }
  }

  const handleGetStoreGroupInvites = async (): Promise<StoreGroupInvite[]> => {
    try {
      enableLoad()

      const response = await GetRequest<StoreGroupInvite[]>(API_ROUTES.STORE_GROUPS.INVITES)

      if (response.success) {
        return response.data ?? []
      }

      throw new Error(response.message)
    } catch (error) {
      handleError(error)

      return []
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetStoreGroups,
    handleGetStoreGroupInvites,
  }
}
